var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1 ml-4",attrs:{"headers":_vm.headers,"items":_vm.graduations,"hide-default-footer":"","sort-by":"number"},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('p',{staticClass:"btn blue--text",on:{"click":function($event){return _vm.loadSingleGraduation(item)}}},[_vm._v(_vm._s(item.name))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }